module.exports = __webpack_public_path__ + "static/media/moonbg.bdb22c2f.jpg";